module.exports = __webpack_public_path__ + "static/05 -northwestern_university-logo-eb344b4340286c2d831a1979101340d0.png";